import {
  Stack,
  TabsProvider,
  Tab,
  Tabs,
  TabPanels,
  TabPanel,
} from 'braid-design-system';
import type { ReactNode } from 'react';

import type { ProfileView } from '../../../types/profile.types';
import { ProfileViewCard } from '../ProfileViewCard/ProfileViewCard';

export type TabContent = {
  key: ProfileTabKey;
  title: string;
  component: ReactNode;
};

export type ProfileTabKey =
  | 'profile'
  | 'interactions'
  | 'no-interactions'
  | 'cv-preview';

export type TabChangeProps = {
  selectedTab: ProfileTabKey;
  onTabChange: (key: ProfileTabKey) => void;
};
interface Props {
  profile: ProfileView;
  profileUrl: string;
  tabs: TabContent[];
  tabChangeProps?: TabChangeProps;
}
export const SignedInProfileView = ({
  profile,
  profileUrl,
  tabs,
  tabChangeProps,
}: Props) => {
  const shouldRenderContentInTabs = tabs.length > 1;

  if (tabs.length === 0) {
    return (
      <ProfileViewCard
        profile={profile}
        isSignedIn={true}
        profileUrl={profileUrl}
      />
    );
  }

  return (
    <Stack space="xlarge">
      <ProfileViewCard
        profile={profile}
        isSignedIn={true}
        profileUrl={profileUrl}
        onLastInteractionClick={() =>
          tabChangeProps?.onTabChange?.('interactions')
        }
      />

      {shouldRenderContentInTabs ? (
        <TabsProvider
          selectedItem={tabChangeProps?.selectedTab ?? 'profile'}
          onChange={(_, item) => {
            if (item !== undefined) {
              tabChangeProps?.onTabChange?.(item as ProfileTabKey);
            }
          }}
        >
          <Stack space="medium">
            <Tabs label="Profile content tabs" divider="full">
              {tabs.map(({ title, key }) => (
                <Tab item={key} key={key}>
                  {title}
                </Tab>
              ))}
            </Tabs>
            <TabPanels>
              {tabs.map(({ title, component }) => (
                <TabPanel key={title}>{component}</TabPanel>
              ))}
            </TabPanels>
          </Stack>
        </TabsProvider>
      ) : (
        <>{tabs[0].component}</>
      )}
    </Stack>
  );
};
